import { SignupVerifyPhoneScreen } from "@/features/auth/screens/SignupVerifyPhoneScreen";
import { signupVerifyPhoneRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

function SignupVerifyPhonePage() {
    const { phone } = Route.useSearch();
    return <SignupVerifyPhoneScreen phone={phone} />;
}

export const Route = createFileRoute("/_auth/_public/signup/verify-phone")({
    component: SignupVerifyPhonePage,
    validateSearch: (search) => signupVerifyPhoneRouteSearchSchema.parse(search),
});
